import React from 'react';
import PropTypes from 'prop-types';
import Button from './Button';
import Icon from '../Icons/Icon';

const TileButton = ({ title, text, iconName, iconFill, onClick, classes }) => (
  <Button onClick={onClick} classes={`tile-btn card-link bg-white border-bottom-4 border-bottom-color-${iconFill || 'green'} ${classes}`} faux>
    <div className="tile-btn__inner">
      <Icon name={iconName} fill={iconFill} size="m" classes="tile-btn_icon" />
      <h2 className="tile-btn__title card-link__text-change like-h5 fw-medium">{title}</h2>
      <p className="tile-btn__subtitle color-grey m-b-0">{text}</p>
    </div>
  </Button>
);

TileButton.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  iconName: PropTypes.string,
  iconFill: PropTypes.string,
  onClick: PropTypes.func,
  classes: PropTypes.string,
};

export default TileButton;



// WEBPACK FOOTER //
// ./library/app/components/Global/Buttons/TileButton.js